import { Checkbox } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { omit } from "lib/omit"

export function SelectItemCheckbox() {
    const { selectedItems, setSelectedItems, selectedId, group } = useBoundContext()

    return (
        <Checkbox
            checked={!!selectedItems[selectedId]}
            onClick={() => handleSelect({ selectedItems, setSelectedItems, selectedId })}
            data-cy="select-item-checkbox"
            disabled={group?.readOnly}
        />
    )
}

function handleSelect({ selectedItems, setSelectedItems, selectedId }) {
    const deselect = Boolean(selectedItems[selectedId])
    if (deselect) {
        setSelectedItems((selected) => omit(selected, selectedId))
    } else {
        setSelectedItems((selected) => ({ ...selected, [selectedId]: true }))
    }
}
